



































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import UserResearchCenter from "@/models/security/userResearchCenter.Model";
import Tag from "../../models/history/tag.model";
import Record from "../../models/history/record.model";
import HistoryService from "@/services/History.service";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import BTableColumn from "@/models/base/BTableColumn.model";
import BaseSelectTag from "@/components/base/baseSelectTag/baseSelectTag.vue";
import fileService from "@/services/file.service";
import RecordTag from "../../models/history/recordTag.model";
@Component({
  components: {
    BaseSelectTag
  }
})
export default class ResearchCenterCollaboratorAdd extends GenericAdd<Record> {
  loading: boolean = false;
  tagLoading: boolean = false;
  tagModel: Tag = new Tag();
  model: Record = new Record();
  historyService: HistoryService = new HistoryService();
  tableConfig: BTableConfig<Tag> = new BTableConfig<Tag>();
  file: any = null;
  tags: any = [];

  constructor() {
    super();
    //this.tableConfig.controller = "Tag";
    this.controller = "Record";
    this.model = new Record();
  }

  mounted() {
    //this.formatColumns();
  }

  cancel_custom() {
    let id = this.$route.params.hasOwnProperty("id")
      ? Number(this.$route.params.id)
      : null;
    if (id && !isNaN(id)) {
      if (this.modelDoNotChange) {
        this.$router.push(`/historico/padre/${id}`);
        return;
      }

      this.$buefy.dialog.confirm({
        title: "Advertencia",
        type: "is-warning",
        size: "is-medium",
        hasIcon: true,
        confirmText: "Salir",
        cancelText: "No",
        message: "¿Seguro que desea salir de la sección?",
        onConfirm: () => this.$router.push(`/historico/padre/${id}`)
      });
    } else {
      this.cancel();
    }
  }

  setTags(data: []) {
    this.tags = data;
  }

  cleanWithFile() {
    this.file = null;
    this.clean();
  }

  async saveRecords() {
    if (this.model.name) {
      this.loading = true;
      let doc = await fileService.upload(this.file);
      doc.refEntityKey = "Id";
      doc.refEntityName = "Record";
      this.model.document = doc;
      if (this.tags) {
        this.tags.forEach(tag => {
          let recordTag = new RecordTag();
          recordTag.tagId = tag.id;
          this.model.recordTags.push(recordTag);
        });
      }
      await this.historyService.saveRecord(this.model);
      this.loading = false;
      this.operationSuccess();
    } else {
      this.operationNoAllowed("Debe escribir un nombre");
    }
  }

  async saveTag() {
    if (this.tagModel.name) {
      this.tagLoading = true;
      this.historyService.saveTag(this.tagModel).then(response => {
        this.tableConfig.reload();
        this.operationSuccess();
        this.tagLoading = false;
      });
    } else {
      this.operationNoAllowed("Debe agregar un tag");
    }
  }

  async removeTag(id: number, tag: Tag) {
    this.loading = true;
    await this.historyService.deleteTag(id);
    this.tableConfig.reload();
    this.operationSuccess();
    this.loading = false;
  }

  protected async validate() {
    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.add();
        return;
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }

  protected async add() {
    try {
      if (this.model.name) {
        this.loading = true;
        this.saving = true;

        if (this.file) {
          let doc = await fileService.upload(this.file);
          doc.refEntityKey = "Id";
          doc.refEntityName = "Record";
          this.model.document = doc;
        }

        if (this.tags) {
          this.tags.forEach(tag => {
            let recordTag = new RecordTag();
            recordTag.tagId = tag.id;
            this.model.recordTags.push(recordTag);
          });
        }

        let id = this.$route.params.hasOwnProperty("id")
          ? Number(this.$route.params.id)
          : null;
        if (id && !isNaN(id)) {
          this.model.parentId = id;
        }

        let result = await this.repository.create(this.model);
        this.saving = false;
        this.loading = false;
        this.$emit("add", result);
        this.clean();
        this.operationSuccess();

        if (this.exitOnSave) {
          let id = this.$route.params.hasOwnProperty("id")
            ? Number(this.$route.params.id)
            : null;
          if (id && !isNaN(id)) {
            this.$router.push(`/historico/padre/${id}`);
          } else {
            this.confirmedCancel();
          }
        }
      } else {
        this.operationNoAllowed("Debe escribir un nombre");
        return;
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }

  get showFileInput() {
    return this.$store.state.showFileInput;
  }

  get user() {
    return this.$store.state.user;
  }
}
